import axios from "@/api/axiosInstance";
import {
  CourseViewer,
  DataEnvelope,
} from "@/modules/learningCenter/features/CourseDirectory/types/viewer";

// Learner-facing course viewer detail: the course graph plus the caller's own
// enrollment (if any), per-module progress and the resume pointer. Available
// to any authenticated user; published courses only.
export const getCourseViewer = async (
  uuid: string,
  signal?: AbortSignal,
): Promise<CourseViewer> => {
  const response = await axios.get<DataEnvelope<CourseViewer>>(
    `/api/private/learning-center/courses/${uuid}/viewer`,
    { signal },
  );
  return response.data.data;
};
